import React, { FC } from 'react';

import { ICONOSTASIS_IMAGE_MAP } from './constants';
import { IconostasisImageBaseProps, IconostasisImageName } from './types';

export interface IconostasisImageProps extends IconostasisImageBaseProps {
    name: IconostasisImageName;
}

export const IconostasisImage: FC<IconostasisImageProps> = ({ name, ...props }) => {
    const Component = ICONOSTASIS_IMAGE_MAP[name];

    // Пропускаем дорогой метчинг union-ов, доверяем дженерику выше
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <Component {...(props as any)} />;
};
